var collapsible_list_component_rtlignore_default = {
  "ltr": "mn0y3",
  "rtl": "RJpYS",
  "iconContainer": "sUonR",
  "icon": "loaVg",
  "isExpanded": "VDufQ",
  "listDimensions": "qim86"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
